/**
 * Common exclusive watermark img.
 * @type {string}
 */
export const COMMON_EXCLUSIVE_WATERMARK_IMG = 'common-exclusive-watermark-img';

/**
 * @type {number}
 */
export const WATER_MARK_RESOLUTION_TYPE = 3;

/**
 * @type {number}
 */
export const HIGH_RES_RESOLUTION_TYPE = 4;

/**
 * @type {number}
 */
export const WEB_RES_RESOLUTION_TYPE = 8;

/**
 * @type {{
 *  3: string,
 *  4: string,
 *  8: string,
 * }}
 */
export const MAPPED_RESOLUTIONS_DOWNLOAD_TYPES = {
    [WATER_MARK_RESOLUTION_TYPE]: 'WaterMark',
    [HIGH_RES_RESOLUTION_TYPE]: 'HighRes',
    [WEB_RES_RESOLUTION_TYPE]: 'WebRes',
};
